/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedAvailabilityPerStoreResult } from '../../models/paginated-availability-per-store-result';

export interface StoresStoreIdCatalogEntriesAvailabilityGet$Params {
  storeId: string;

/**
 * Size of the results page.
 */
  size?: number;
  start?: string;

/**
 * Filters items by catalog entry type. COMPOSITE covers both combo and container catalog entries - there is no separate CONTAINER value at the filter layer today. Optional; if omitted, all item types are returned.
 */
  itemType?: 'PRODUCT' | 'COMPOSITE' | 'MODIFIER';

/**
 * Filters items by out-of-stock channel. any_channel filters by the item-level out-of-stock flag regardless of channel; no_channel returns items with no channel-specific out-of-stock set; all_channels is a legacy alias for any_channel kept for backward compatibility. Otherwise a known ordering channel or aggregator id. Optional; if omitted, all items are returned regardless of out-of-stock status. This list does not yet include every aggregator live in production (e.g. Rappi, Didi have no confirmed wire-level identifier in this service today) - confirm with the aggregator config owner before extending it.
 */
  outOfStockChannel?: 'any_channel' | 'no_channel' | 'all_channels' | 'web' | 'call_center' | 'mobile' | 'kiosk' | 'indoor_digital_menu_board' | 'outdoor_digital_menu_board' | 'chat' | 'doordash' | 'ubereats' | 'glovo' | 'postmates' | 'grubhub';
}

export function storesStoreIdCatalogEntriesAvailabilityGet(http: HttpClient, rootUrl: string, params: StoresStoreIdCatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedAvailabilityPerStoreResult>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdCatalogEntriesAvailabilityGet.PATH, 'get');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
    rb.query('itemType', params.itemType, {});
    rb.query('outOfStockChannel', params.outOfStockChannel, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedAvailabilityPerStoreResult>;
    })
  );
}

storesStoreIdCatalogEntriesAvailabilityGet.PATH = '/stores/{storeId}/catalog-entries/availability';
